var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"counter"},[_c('span',{class:['far fa-minus', this.value <= 0 && 'disabled'],on:{"click":_vm.minus}}),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('span',{class:['far fa-plus', this.value >= _vm.max && 'disabled'],on:{"click":_vm.plus}})])
}
var staticRenderFns = []

export { render, staticRenderFns }